<template>
    <div>
        <div class="nuovo-lab-container">
            <span @click="$bvModal.show('createLabModal')"><small>+ Nuovo laboratorio</small></span>
        </div>
        <b-list-group>
            <b-list-group-item v-if="!labsList.length" variant="secondary"><span>Non ci sono laboratori da visualizzare.</span></b-list-group-item>
            <b-list-group-item button class="list-item" v-for="lab in labsList" :key="lab.uid">
                <b-row >
                    <b-col class="list-item-left"><span> {{lab.first_name}}</span></b-col>
                    <b-col class="list-item-right">
                        <img src="@/assets/lock.svg" class="list-img-info" @click="openPasswordModal(lab)"/>
                        <img src="@/assets/info.svg" class="list-img-info" @click="openViewModal(lab)"/>
                        <img src="@/assets/delete.svg" class="list-img-delete" @click="openUnverifyModal(lab)"/>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>
        <!-- Modal listino prezzi -->
        <b-modal id="viewModal" size="lg" :hide-header="true" button-size="sm" ok-variant="success" cancel-title="Annulla">
            <div class="x-container" @click="$bvModal.hide('viewModal');">
                <img class="x-img" src="@/assets/x.svg" />
            </div>
            <div class="editModalTitle">
                <h1>{{labToView.first_name}}</h1>
            </div>
            <hr>
            <div class="d-flex justify-content-between align-items-center view-modal-rows view-modal-rows-top">
                <span><small>Username: </small></span>
                <span> {{labToView.username}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center view-modal-rows view-modal-rows-bottom">
                <span><small>Codice ministeriale: </small></span>
                <span> {{labToView.unique_id}}</span>
            </div>
        </b-modal>
        <!-- Fine modal listino prezzi -->
        <!-- Modal cambio password -->
        <b-modal id="passwordModal" size="lg" :hide-header="true" button-size="sm" ok-variant="success" cancel-title="Annulla" @ok="changePassword">
            <div class="x-container" @click="$bvModal.hide('passwordModal');">
                <img class="x-img" src="@/assets/x.svg" />
            </div>
            <div class="editModalTitle">
                <h1>{{labToChangePass.username}}</h1>
            </div>
            <hr>
            <div class="cambia-pass-body">
                <span>Vuoi cambiare la password per questo laboratorio?</span>
                <b-form class="cambia-pass-form">
                    <b-form-group label="Nuova password" label-for="password">
                        <b-form-input
                            id="password"
                            v-model="newPassword"
                            required
                            type="password"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Conferma password" label-for="password">
                        <b-form-input
                            id="password"
                            v-model="confirmPassword"
                            required
                            :state="passwordsMatch"
                            aria-describedby="password-mismatch"
                            type="password"
                        ></b-form-input>
                        <b-form-invalid-feedback id="password-mismatch">
                            Le due password inserite non sono uguali.
                        </b-form-invalid-feedback>

                    </b-form-group>
                </b-form>
            </div>
        </b-modal>
        <!-- Fine modal cambio password -->
        <b-modal id="confirmDelete" size="lg" v-if="labToUnverify" :title="labToUnverify.username" button-size="sm" ok-variant="danger" cancel-title="Annulla" @ok="unverifyLab">
            <span> Sei sicuro di voler rimuovere accesso a questo Laboratorio?</span>
        </b-modal>
         <!-- Modal crea lab -->
        <b-modal id="createLabModal" size="lg" :hide-header="true" button-size="sm" ok-variant="success" cancel-title="Annulla" @ok="createLab">
            <div class="x-container" @click="$bvModal.hide('createLabModal');">
                <img class="x-img" src="@/assets/x.svg" />
            </div>
            <div class="editModalTitle">
                <h1>Nuovo Laboratorio</h1>
            </div>
            <hr>
            <div class="cambia-pass-body">
                <b-alert :show="missingFieldAlert" dismissible @dismissed="missingFieldAlert=false;" variant="danger">Assicurarsi che tutti i campi siano stati completati.</b-alert>
                <b-form class="cambia-pass-form">
                    <b-form-group label="Nome del laboratorio" label-for="nome">
                        <b-form-input
                            id="nome"
                            v-model="nomeNewLab"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Codice identificativo ministeriale del laboratorio" label-for="codice_id">
                        <b-form-input
                            id="codice_id"
                            v-model="codiceIdNewLab"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Nome utente per il laboratorio" label-for="username">
                        <b-form-input
                            id="username"
                            v-model="usernameNewLab"
                            required
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Password" label-for="passwordNewLab">
                        <b-form-input
                            id="passwordNewLab"
                            v-model="passwordNewLab"
                            required
                            type="password"
                        ></b-form-input>
                    </b-form-group>
                </b-form>
            </div>
        </b-modal>
        <!-- Fine modal crea lab -->
    </div>
</template>

<script>
import { mixins } from "@/mixins";

export default {
    name: "ListaLabs",
    data() {
        return{
            labsList: Array,
            labToView: Object,
            labToUnverify: Object,
            labToChangePass: Object,
            newPassword: '',
            confirmPassword: '',
            passwordsMatch: null,
            nomeNewLab: null,
            usernameNewLab: null,
            passwordNewLab: null,
            codiceIdNewLab: "",
            missingFieldAlert: false,
        }
    },
    mounted(){
        this.getLabs();
    },
    mixins: [mixins],
    methods:{
        openViewModal: function(lab){
            this.labToView = lab;
            this.$bvModal.show('viewModal');
        },
        openPasswordModal: function(lab){
            this.labToChangePass = lab;
            this.$bvModal.show('passwordModal');
        },
        openUnverifyModal: function(lab){
            this.labToUnverify = lab;
            this.$bvModal.show('confirmDelete');
        },
        unverifyLab: function(){
            this.$axios
            .patch(this.$apibase + '/api/users/' + this.labToUnverify.uid + '/',
                {
                    is_verified: false,
                    is_active: false,
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    }
                }
            )
            .then(() => {
                let lab_index = this.labsList.indexOf(this.labToUnverify);
                this.labsList.splice(lab_index, 1);
                this.labToUnverify = null;
                this.$store.dispatch('setAlert', {message: "Laboratorio rimosso con successo.", type: 'success'});
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        changePassword: function (bvModalEvt){
            bvModalEvt.preventDefault()
            if (this.newPassword.localeCompare(this.confirmPassword) != 0){
                this.passwordsMatch = false
                return;
            }
            this.$axios
            .patch(this.$apibase + '/api/users/' + this.labToChangePass.uid + '/',
                {
                    password: this.newPassword,
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    }
                }
            )
            .then(() => {
                this.labToChangePass = null;
                this.newPassword = '';
                this.confirmPassword = '';
                this.$bvModal.hide('passwordModal');
                this.$store.dispatch('setAlert', {message: "Password cambiata con successo", type: 'success'});
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        getLabs: function(){
            this.$axios
            .get(this.$apibase + "/api/users/get_labs/", {
                headers: {
                    Authorization:"JWT " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                this.labsList = response.data;
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        },
        createLab: function(bvModalEvt) {
            bvModalEvt.preventDefault()
            if (!(this.nomeNewLab && this.usernameNewLab && this.passwordNewLab && this.codiceIdNewLab)){
                this.missingFieldAlert = true;
                return;
            }
            this.$axios
            .post(this.$apibase + '/api/users/create_lab/',
                {
                    first_name: this.nomeNewLab,
                    username: this.usernameNewLab,
                    unique_id: this.codiceIdNewLab,
                    password: this.passwordNewLab
                },
                {
                    headers: {
                        Authorization:"JWT " + localStorage.getItem('access_token')
                    }
                }
            )
            .then(() => {
                this.nomeNewLab = '';
                this.usernameNewLab = '';
                this.codiceIdNewLab = '';
                this.passwordNewLab = '';
                this.getLabs()
                this.$bvModal.hide('createLabModal');
                this.$store.dispatch('setAlert', {message: "Nuovo laboratorio creato con successo", type: 'success'});
            })
            .catch((e)=>{
                if (e.response.status == 403)
                    this.logout();
                else
                    alert(e);
            })
        }
    }

}
</script>

<style scoped>
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
        color: #707070;
    }
    .list-item-left{
        text-align: left;
    }
    .list-item-right{
        text-align: right;
    }
    .list-img-info{
        width: 15px;
        margin-right: 20px;
        cursor: pointer;
    }
    .list-img-delete{
        width:20px;
        cursor: pointer;   
    }
    .x-container{
        text-align: right;
        margin-bottom: 20px;
        padding-right: 30px;
        cursor: pointer;
    }
    .x-img{
        width: 15px;
    }
    .editModalTitle{
        text-align: center;
        padding: 20px 0 40px;
    }
    .cambia-pass-form{
        padding-top: 30px;
    }
    .cambia-pass-body{
        padding: 20px 50px;
    }
    .nuovo-lab-container{
        text-align: right;
        margin-bottom: 20px;
        cursor: pointer;
    }
    .view-modal-rows{
        width: 200px;
        padding-left: 30px;
        text-align: left;
        margin-top:10px;
    }

    .view-modal-rows-top{
        margin-top: 30px;
    }
    .view-modal-rows-bottom{
        margin-bottom: 10px;
    }
</style>